import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { GetNotificationSettingsRequest, UpdateNotificationSettingsRequest } from "./api";

type Props = {
    onSuccess?: (data: any) => void;
    onError?: (error: any) => void;
}

export type NotificationSettings = {
  id: number;
  email: string;
  name: string;
  new_candidate: boolean;
  new_application: boolean;
}

export type SettingsResponse = {
  agency: NotificationSettings;
  agents: NotificationSettings[];
}

const useGetNotificationSettings = (props?: Props) => {
    const {data, isLoading, isError} = useQuery<SettingsResponse>(['settings'], GetNotificationSettingsRequest, {
        onSuccess: props?.onSuccess,
        onError: props?.onError,
    });

    return {data, isLoading, isError};
};

const useUpdateNotificationSettings = (props?: Props) => {
  const queryClient = useQueryClient();
  const {mutate, isLoading, isError, error} = useMutation(UpdateNotificationSettingsRequest, {
      onSuccess: (data: any) => {
          queryClient.invalidateQueries(['settings']);
          props?.onSuccess && props.onSuccess(data);
      },
      onError: props?.onError,
  });

  return {mutate, isLoading, isError, error};
};

export { useGetNotificationSettings, useUpdateNotificationSettings };